<template>
  <div>
    <div class="contant-wrap">
      <h4>消息</h4>
      <div class="content">
        <h3>{{msgDetail.messageHead}}</h3>
        <p>{{msgDetail.activeTime}}</p>
        <div class="html" v-html="msgDetail.messageBody"></div>
      </div>
    </div>
    
  </div>
</template>


<script>
export default {
  data() {
    return {
      msgDetail: {}
    }
  },
  methods: {
    getData() {
      const { id } = this.$route.query;
      this.$api.global.getMessage({id}).then((res) => {
        this.msgDetail = res;
      })
    }
  },
  mounted() {
    this.getData();
  },
  beforeRouteUpdate (to, from, next) {
    next();
    this.getData();
  },
}
</script>

<style lang="scss" scoped>
  h4 {
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #EEEEEE;
    padding-bottom: 15px;
  }
  .content {
    width: 750px;
    margin: 30px auto;
    h3 {
      text-align: center;
      font-size:20px;
      font-family:MicrosoftYaHei;
      font-weight:bold;
      color:rgba(51,51,51,1);
    }
    p {
      margin-top: 15px;
      text-align: center;
      font-size:14px;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(153,153,153,1);
    }
    .html {
      margin-top: 30px;
    }
  }
</style>